/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   openMessageModalWithIntent thunk
 */

import type { ShowMessagingModalData } from '@zcode/state-type'
import type { Dispatch } from 'redux'
import type { DistributedPick } from 'type-fest'
import { trackMessageImpression } from '../../../traktor/thunks/trackMessageImpression'
import { showMessagingModal } from './showMessagingModal'

export const openMessageModalWithIntent =
  (
    messageData: DistributedPick<
      ShowMessagingModalData,
      | 'analyticChannel'
      | 'currentTab'
      | 'entity'
      | 'equalCTAIntent'
      | 'hasInstantTourAvailability'
      | 'origin'
      | 'selectedFloorplan'
      | 'selectedUnit'
      | 'viewingId'
      | 'viewingTime'
    > & { showDatePicker?: boolean }
  ) =>
  (dispatch: Dispatch) => {
    const { entity, equalCTAIntent, origin } = messageData
    dispatch(trackMessageImpression({ entity, origin, contactFormAction: equalCTAIntent }))
    dispatch(showMessagingModal(messageData))
  }
